const ohMkrProcessModeOnChange = async ({ props, formData, updateState, config, switchModNm, ...data }) => {
    var mod = formData.processingMode;
    if (mod) {
        console.log("print mod", mod)
        let newModNm = mod === 'Realtime' ? 'rlsRjtOnHoldTrxnOnline' : 'rlsRjtOnHoldTrxn';
        console.log("Current Module Name", newModNm)
        var changed = switchModNm({ newModNm, formData, updateState });
      
        if (!changed) {
            updateState({ newFormData: formData })
        }
        return;
    }
    updateState({ newFormData: formData })
}

const ohChkrProcessModeOnChange = async ({ props, formData, updateState, config, switchModNm, ...data }) => {
    var mod = formData.processingMode;
    if (mod) {
        console.log("print mod", mod)
        let newModNm = mod === 'Realtime' ? 'rlsRjtOnHoldTrxnOnline' : 'rlsRjtOnHoldTrxnBtchChkr';
        console.log("Current Module Name", newModNm)
        var changed = switchModNm({ newModNm, formData, updateState });
      
        if (!changed) {
            updateState({ newFormData: formData })
        }
        return;
    }
    updateState({ newFormData: formData })
}




export { ohMkrProcessModeOnChange, ohChkrProcessModeOnChange }